"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Billing = void 0;
const BillingEmail_1 = require("./billing/BillingEmail");
const InvoiceRecipients_1 = require("./billing/InvoiceRecipients");
exports.Billing = {
    billing_email: BillingEmail_1.BillingEmail,
    invoice_recipients: InvoiceRecipients_1.InvoiceRecipients,
};
